// Importing functions to create and configure Redux store
import { combineReducers, configureStore } from "@reduxjs/toolkit";

// Importing reducers for authentication and user-related state
import authReducer from "../redux/slices/authSlice";
import userReducer from "../redux/slices/userSlice";

// Combine all slice reducers into a single root reducer
const rootReducer = combineReducers({
  auth: authReducer, // Handles authentication state
  user: userReducer, // Handles user-related state
});

// Create and configure the Redux store with the root reducer
const store = configureStore({ reducer: rootReducer });

// Export the configured store for use in the app
export default store;
